import { FC, useContext } from 'react';
import { useRouter } from 'next/router';

import { i18n as I18n } from 'utils/i18n';
import useRelatedSpaces from '../../hooks/useRelatedSpaces';

import FavouriteSpace from '../favouriteSpace';
import { SearchContext } from '../../state/search';

interface Space {
  id: number;
  venue: Venue;
  categories: string[];
}

interface Venue {
  id: number;
  name: string;
  address: Address;
}

interface Address {
  postcode: string;
}

interface Props {
  space: Space;
  disabledSpaceIds: number[];
  selectSpace: (space: Space, venue: Venue) => void;
}

const RelatedSpaces: FC<Props> = ({
  space,
  disabledSpaceIds = [],
  selectSpace,
}) => {
  const { data: relatedSpaces } = useRelatedSpaces(space.id);
  const router = useRouter();

  const { actions } = useContext(SearchContext);

  const viewAll = () => {
    actions.updateLocation(space.venue.address.postcode);
    actions.updateDistance(5);
    actions.updateRoomTypes([space.categories[0]]);

    router.push(`/find-rooms`);
  };

  if (relatedSpaces.length === 0) {
    return null;
  }

  return (
    <div className="related-spaces">
      <div className="related-spaces__header">
        <h3 className="related-spaces__title">
          {I18n.t('related_spaces.title')}
        </h3>

        <button onClick={viewAll} className="button button--text">
          {I18n.t('related_spaces.view_all')}
        </button>
      </div>

      <div className="related-spaces__inner">
        {relatedSpaces.map(relatedSpace => (
          <FavouriteSpace
            key={`space-${relatedSpace.id}`}
            space={relatedSpace}
            selectSpace={
              selectSpace && !disabledSpaceIds.includes(Number(relatedSpace.id))
                ? () => selectSpace(relatedSpace, relatedSpace.venue)
                : undefined
            }
          />
        ))}
      </div>
    </div>
  );
};

export default RelatedSpaces;
